/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import type { WorkspacePresetLabels } from '../../store/workspace/types';
import type { WorkspacePresetFormValues } from '../../store/workspaceList/types';
import PresetLabelsPanelWrapper from '../LabelsPanel/PresetsLabelsPanelWrapper';

export interface WorkspaceMenuLabelsPanelProps {
  value?: WorkspacePresetLabels;
  onChange?: (labels: WorkspacePresetLabels) => void;
  menuLabels?: WorkspacePresetLabels;
}

const WorkspaceMenuLabelsPanel: React.FC<WorkspaceMenuLabelsPanelProps> = ({
  value,
  onChange,
  menuLabels,
}) => {
  const methods = useForm<WorkspacePresetFormValues>({
    defaultValues: {
      labels: value ?? {},
      views: [],
    } as Partial<WorkspacePresetFormValues>,
  });

  return (
    <FormProvider {...methods}>
      <PresetLabelsPanelWrapper
        data-testid="workspace-menu-labels-panel"
        isMenuFilterMode
        menuLabels={menuLabels}
        onLabelsChange={onChange}
      />
    </FormProvider>
  );
};

export default WorkspaceMenuLabelsPanel;
